import { render } from "./hospitals.vue?vue&type=template&id=3881f667"
import script from "./hospitals.ts?vue&type=script&lang=js"
export * from "./hospitals.ts?vue&type=script&lang=js"

import exportComponent from "I:\\Dev\\Projects\\LabManagement\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__